/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { ActiveSection } from "./constants";

export const CustomerCRMTabs = defineComponent<{
  activeSection: ActiveSection;
  ordersCount: number;
  fallbackOrdersCount: number;
  reservationsCount: number;
  fallbackReservationsCount: number;
  ordersLoaded: boolean;
  reservationsLoaded: boolean;
  loadingOrders: boolean;
  loadingReservations: boolean;
  onChange: (section: ActiveSection) => void;
}>({
  name: "CustomerCRMTabs",
  props: [
    "activeSection",
    "ordersCount",
    "fallbackOrdersCount",
    "reservationsCount",
    "fallbackReservationsCount",
    "ordersLoaded",
    "reservationsLoaded",
    "loadingOrders",
    "loadingReservations",
    "onChange",
  ],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="flex overflow-y-hidden overflow-x-auto border-b border-base-content/8 bg-base-200/100 flex-shrink-0 px-2">
        {(
          [
            { key: "overview", label: t("reservations.customers.overview"), icon: "dashboard", loading: false },
            {
              key: "orders",
              label: t("reservations.customers.orders_count", [
                props.ordersLoaded ? props.ordersCount : props.fallbackOrdersCount,
              ]),
              icon: "receipt_long",
              loading: props.loadingOrders,
            },
            {
              key: "reservations",
              label: t("reservations.customers.reservations_count", [
                props.reservationsLoaded ? props.reservationsCount : props.fallbackReservationsCount,
              ]),
              icon: "event_seat",
              loading: props.loadingReservations,
            },
          ] as const
        ).map((tab) => (
          <button
            key={tab.key}
            onClick={() => props.onChange(tab.key)}
            class={`flex flex-shrink-0 items-center gap-1.5 px-4 py-2.5 text-xs font-medium transition-colors duration-100 border-b-2 -mb-px focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:outline-none ${
              props.activeSection === tab.key
                ? "border-primary text-primary"
                : "border-transparent text-base-content/35 hover:text-base-content/55"
            }`}
          >
            <span class="material-symbols-outlined text-[14px]">{tab.icon}</span>
            {tab.label}
            {tab.loading && <span class="loading loading-spinner w-3 h-3 ml-1" />}
          </button>
        ))}
      </div>
    );
  },
});
